<template>
  <div class="about">
    <div class="login-after-box" v-if="isLogin && IsWap">
      <div class="hello-msg-box">
        <span>欢迎您，</span>
        <span>{{name}}</span>
      </div>
      <a @click="doLogout">退出</a>
    </div>
  </div>
</template>

<script>
import { setCookie, getCookie, removeCookie } from "../utils/public";
import VueCookies from "vue-cookies";
export default {
  name: "About",
  data() {
    return {
      isLogin: false,
      IsWap: false,
      name: ""
    };
  },
  props: ["screenWidth"],
  computed: {
    loginStatus() {
      return this.$store.state.loginStatus;
    }
  },
  mounted() {
    if (this.screenWidth < 750) {
      this.IsWap = true;
    } else {
      this.IsWap = false;
    }
  },
  watch: {
    loginStatus: function(val, oVal) {
      let self = this;
      if (val == 1) {
        setTimeout(function() {
          self.isLogin = true;
          self.name =
            self.$store.state.info.firstName + self.$store.state.info.lastName;
        }, 1000);
      } else {
        self.isLogin = false;
      }
    },
    screenWidth: function(val, oVal) {
      if (val < 750) {
        this.IsWap = true;
      } else {
        this.IsWap = false;
      }
    }
  },
  methods: {
    doLogout: function() {
      removeCookie("sess");
      removeCookie("globalUserId");
      removeCookie("smarketMember_" + window.config.schemaId);
      removeCookie("username");
      VueCookies.set("isKeeAutoLogin", "");
      this.$store.commit("setLoginStatus", 0);
      this.$store.commit("setUserInfo", {});
    }
  }
};
</script>

<style lang="scss" scoped>
@media (min-width: 750px) {
  .about {
    padding: 0 32px 30px;
    background-color: #f7f7f7;

    .about-before-box,
    .about-after-box {
      .about-tittle {
        font-size: 15px;
        font-weight: bold;
        color: $commonRed;
        line-height: 25px;
      }

      .about-content {
        font-size: 13px;
        line-height: 20px;
        color: $color;
      }
    }
    .about-before-box {
      padding-top: 30px;
      border-top: 1px solid #efeeef;
    }

    .about-qrcode-box {
      padding-top: 22px;
      overflow: hidden;

      .qrcode-box {
        float: left;
        margin-right: 17px;
        img {
          width: 92px;
        }
      }

      .text-box {
        padding-top: 17px;
        color: $color;
        span {
          color: $commonRed;
        }
      }
    }
  }
}
@media (max-width: 750px) {
  .about {
    background-color: #f7f7f7;
    margin: 0 4%;

    .login-after-box {
      margin: pxToRem(30) 0;
      padding: pxToRem(68) pxToRem(28) pxToRem(38);
      text-align: center;
      border-top: 2px solid $commonRed;
      background: #f7f7f7;

      .hello-msg-box {
        font-size: pxToRem(34);
        padding-bottom: pxToRem(30);
        font-weight: bold;
        color: $commonRed;
      }

      a {
        font-size: pxToRem(24);
        color: $color;
        cursor: pointer;
        text-decoration: none;
        border-bottom: 1px solid #666666;
      }
    }
    .about-before-box,
    .about-after-box {
      padding: pxToRem(25) pxToRem(28) pxToRem(0);
      border-top: 1px solid #ededed;
      .about-tittle {
        font-size: pxToRem(24);
        font-weight: bold;
        color: $commonRed;
      }
      .about-content {
        margin-top: pxToRem(10);
        font-size: pxToRem(22);
        line-height: pxToRem(35);
        color: $color;
      }
    }
    .about-before-box {
      border: 0;
      margin-top: pxToRem(50);
      /*padding-top: pxToRem(45);*/
    }

    .about-qrcode-box {
      padding: pxToRem(30) pxToRem(28) pxToRem(35);
      position: relative;

      .qrcode-box {
        img {
          width: pxToRem(130);
        }
      }

      .text-box {
        position: absolute;
        left: pxToRem(175);
        top: pxToRem(36);
        font-size: pxToRem(22);
        padding-top: pxToRem(25);
        color: $color;
        span {
          color: $commonRed;
        }
      }
    }
  }
}
</style>
